let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let Loading = require("./loading");
let SaveForLaterSearch = require("./moderation-save-for-later-search");
let SaveForLaterSlats = require("./moderation-save-for-later-slats");

class ModerationSaveForLater extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.fetchSavedUploads("");
    }

    loadMoreUploads() {
        if (
            this.props.batch.result !== "SEARCH_SAVED_UPLOADS_SUCCESS" &&
            this.props.batch.pagination
        ) {
            this.props.fetchSavedUploads(
                "",
                this.props.batch.pagination.pageCount + 1
            );
        }
    }

    render() {
        if (this.props.batch.uploads) {
            let button = this.renderButton();

            return (
                <div>
                    <SaveForLaterSearch />
                    <SaveForLaterSlats batch={this.props.batch} />
                    {button}
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderButton() {
        let button = null;

        if (
            this.props.batch.uploads.length !==
            this.props.batch.totalSavedUploads
        ) {
            button = (
                <div>
                    <button
                        className="load-more btn btn-default black"
                        onClick={this.loadMoreUploads.bind(this)}
                    >
                        Load More
                    </button>
                </div>
            );
        }

        return button;
    }
}

function mapStateToProps(state, ownProps) {
    let batch = { uploads: undefined }, keys;

    if (state.uploads.result) {
        batch.result = state.uploads.result;
    }

    if (state.uploads.result) {
        batch.uploads = undefined;

        if (state.uploads.keys) {
            batch.pagination = state.pagination.savedUploads[""];

            if (state.uploadsSaveForLaterSearchKeys.length > 0) {
                batch.uploads = [];
                keys = state.uploadsSaveForLaterSearchKeys;
            } else if (state.uploadsSaveForLaterKeys.length > 0) {
                batch.uploads = [];
                keys = state.uploadsSaveForLaterKeys;
            }

            if (keys) {
                keys.forEach(uploadId => {
                    let upload = state.uploads[uploadId];
                    batch.uploads.push(upload);
                    if (state.uploadsSaveForLaterSearchKeys.length === 0) {
                        batch.totalSavedUploads = state.uploads.counts.saved_batches;
                    } else {
                        batch.totalSavedUploads = state.uploadsSaveForLaterSearchKeys.length;
                    }
                });
            }
        }
    }

    return { batch };
}

module.exports = connect(mapStateToProps, {
    fetchSavedUploads: actions.fetchSavedUploads
})(ModerationSaveForLater);
